"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LostRealtimeSocketMessageModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Notification = require("../Notification");
var _LostRealtimeSocketMessageModal = require("./LostRealtimeSocketMessageModal.styled");
var LostRealtimeSocketMessageModal = exports.LostRealtimeSocketMessageModal = function LostRealtimeSocketMessageModal(_ref) {
  var isOpen = _ref.isOpen;
  return _react["default"].createElement(_reactstrap.Modal, {
    isOpen: isOpen
  }, _react["default"].createElement(_reactstrap.ModalHeader, null, "Lost realtime connection to Studio"), _react["default"].createElement(_reactstrap.ModalBody, null, _react["default"].createElement("p", null, "Your realtime connection is required to send program updates to streams & presenters.", _react["default"].createElement("strong", null, "\xA0 All streams & records will continue.")), _react["default"].createElement("p", null, "Check your internet connection and refresh the page if the connection is not restored. Refresh will not disrupt stream / records."), _react["default"].createElement(_Notification.Notification, {
    message: "Attempting to re-connect...",
    type: "warning",
    isDismissible: false
  })), _react["default"].createElement(_LostRealtimeSocketMessageModal.StyledModalFooter, null, _react["default"].createElement(_LostRealtimeSocketMessageModal.StyledButton, {
    onClick: function onClick() {
      return window.location.reload();
    }
  }, "Refresh the page")));
};
LostRealtimeSocketMessageModal.propTypes = {
  isOpen: _propTypes["default"].bool
};
LostRealtimeSocketMessageModal.defaultProps = {
  isOpen: false
};